import { onlineQuestionnaireSectionLabelsMap } from 'dzb/inquiry/steps/retailerData/sections/onlineQuestionnaireSection/labels';
import { retailerInformationSectionLabelsMap } from 'dzb/inquiry/steps/retailerData/sections/retailerInformationSection/labels';
import { LabelsMap } from 'new/form/common/types';

export const dzbRetailerDataLabelsMap: LabelsMap = {
  ...onlineQuestionnaireSectionLabelsMap,
  ...retailerInformationSectionLabelsMap,
};
